module.exports = __webpack_public_path__ + "static/media/ux.ccd334c8.jpg";